import {
  listProviders as publicListProviders,
  getConnection as publicGetConnection,
  listConnections as publicListConnections,
  connectByOAuth as publicConnectByOAuth,
  connectByCredentials as publicConnectByCredentials,
  listCalendars as publicListCalendars,
  updateSyncConfig as publicUpdateSyncConfig,
  disconnect as publicDisconnect,
  listEvents as publicListEvents,
} from './bookings-calendar-v2-external-calendar-external-calendars.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';

export const listProviders: MaybeContext<
  BuildRESTFunction<typeof publicListProviders> & typeof publicListProviders
> = /*#__PURE__*/ createRESTModule(publicListProviders);
export const getConnection: MaybeContext<
  BuildRESTFunction<typeof publicGetConnection> & typeof publicGetConnection
> = /*#__PURE__*/ createRESTModule(publicGetConnection);
export const listConnections: MaybeContext<
  BuildRESTFunction<typeof publicListConnections> & typeof publicListConnections
> = /*#__PURE__*/ createRESTModule(publicListConnections);
export const connectByOAuth: MaybeContext<
  BuildRESTFunction<typeof publicConnectByOAuth> & typeof publicConnectByOAuth
> = /*#__PURE__*/ createRESTModule(publicConnectByOAuth);
export const connectByCredentials: MaybeContext<
  BuildRESTFunction<typeof publicConnectByCredentials> &
    typeof publicConnectByCredentials
> = /*#__PURE__*/ createRESTModule(publicConnectByCredentials);
export const listCalendars: MaybeContext<
  BuildRESTFunction<typeof publicListCalendars> & typeof publicListCalendars
> = /*#__PURE__*/ createRESTModule(publicListCalendars);
export const updateSyncConfig: MaybeContext<
  BuildRESTFunction<typeof publicUpdateSyncConfig> &
    typeof publicUpdateSyncConfig
> = /*#__PURE__*/ createRESTModule(publicUpdateSyncConfig);
export const disconnect: MaybeContext<
  BuildRESTFunction<typeof publicDisconnect> & typeof publicDisconnect
> = /*#__PURE__*/ createRESTModule(publicDisconnect);
export const listEvents: MaybeContext<
  BuildRESTFunction<typeof publicListEvents> & typeof publicListEvents
> = /*#__PURE__*/ createRESTModule(publicListEvents);

export {
  CalendarType,
  ConnectMethod,
  ListEventFromCalendars,
  SyncToCalendar,
  Status,
  ErrorReason,
  SyncToErrorReason,
  Day,
  Transparency,
  RecurringIntervalType,
  LocationType,
  LocationStatus,
  LocationsLocationType,
  DayOfWeek,
  ApprovalStatus,
  ScheduleStatus,
  ConferenceType,
  SessionStatus,
  SessionType,
} from './bookings-calendar-v2-external-calendar-external-calendars.universal.js';
export {
  ExternalCalendar,
  ListProvidersRequest,
  ListProvidersResponse,
  Provider,
  ProviderFeatures,
  GetConnectionRequest,
  GetConnectionResponse,
  Connection,
  ConnectionSyncConfig,
  Calendar,
  PrimaryCalendar,
  Calendars,
  DedicatedCalendar,
  ConnectionSyncConfigListEventFromCalendars,
  ConnectionSyncConfigListEventFromCalendarsListFromOneOf,
  ConnectionSyncConfigSyncToCalendar,
  ConnectionSyncConfigSyncToCalendarSyncToOneOf,
  ListConnectionsRequest,
  ListConnectionsResponse,
  ConnectByOAuthRequest,
  ConnectByOAuthResponse,
  RawHttpRequest,
  PathParametersEntry,
  QueryParametersEntry,
  HeadersEntry,
  RawHttpResponse,
  ConnectByCredentialsRequest,
  ConnectByCredentialsResponse,
  ListCalendarsRequest,
  ListCalendarsResponse,
  UpdateSyncConfigRequest,
  UpdateSyncConfigResponse,
  DisconnectRequest,
  DisconnectResponse,
  ListEventsRequest,
  CursorPaging,
  ListEventsResponse,
  Event,
  CursorPagingMetadata,
  Cursors,
  ScheduleNotification,
  ScheduleNotificationEventOneOf,
  ScheduleCreated,
  Schedule,
  RecurringInterval,
  Interval,
  Frequency,
  LinkedSchedule,
  Location,
  Address,
  AddressStreetOneOf,
  StreetAddress,
  AddressLocation,
  Subdivision,
  LocationsLocation,
  LocationsAddress,
  LocationsStreetAddress,
  LocationsAddressLocation,
  BusinessSchedule,
  TimePeriod,
  SpecialHourPeriod,
  ExtendedFields,
  Rate,
  Price,
  Availability,
  AvailabilityConstraints,
  SplitInterval,
  Participant,
  ExternalCalendarOverrides,
  Version,
  ConferenceProvider,
  CalendarConference,
  ScheduleUpdated,
  RecurringSessionsUpdated,
  Session,
  CalendarDateTime,
  LocalDateTime,
  ExternalCalendarInfo,
  SessionVersion,
  ParticipantNotification,
  ScheduleCancelled,
  SessionCreated,
  SessionUpdated,
  SessionCancelled,
  AvailabilityPolicyUpdated,
  AvailabilityPolicy,
  IntervalSplit,
  RecurringSessionSplit,
  ScheduleUnassignedFromUser,
  MultipleSessionsCreated,
  ScheduleWithSessions,
  SitePropertiesOnScheduleCreation,
  MigrationEvent,
  MigrationData,
  StaffData,
  Empty,
  ListConnectionsOptions,
  ListEventsOptions,
} from './bookings-calendar-v2-external-calendar-external-calendars.universal.js';
export {
  CalendarTypeWithLiterals,
  ConnectMethodWithLiterals,
  ListEventFromCalendarsWithLiterals,
  SyncToCalendarWithLiterals,
  StatusWithLiterals,
  ErrorReasonWithLiterals,
  SyncToErrorReasonWithLiterals,
  DayWithLiterals,
  TransparencyWithLiterals,
  RecurringIntervalTypeWithLiterals,
  LocationTypeWithLiterals,
  LocationStatusWithLiterals,
  LocationsLocationTypeWithLiterals,
  DayOfWeekWithLiterals,
  ApprovalStatusWithLiterals,
  ScheduleStatusWithLiterals,
  ConferenceTypeWithLiterals,
  SessionStatusWithLiterals,
  SessionTypeWithLiterals,
  ConnectByOAuthApplicationErrors,
  ConnectByCredentialsApplicationErrors,
  ListCalendarsApplicationErrors,
  UpdateSyncConfigApplicationErrors,
  DisconnectApplicationErrors,
} from './bookings-calendar-v2-external-calendar-external-calendars.universal.js';
